import {
  TranslationAlertMessages,
  AlertMessages
} from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationAlertMessages = {
  [AlertMessages.noPermissionCreditLimit]: "You don't have any clients allowed to view credit limits.",
  [AlertMessages.noPermissionInvoices]: "You don't have any clients allowed to view invoices.",
  [AlertMessages.noPermissionCertificates]: "You don't have any clients allowed to view certificates.",
  [AlertMessages.noPermissionConcretingRequest]: "You don't have request permission on any client.",
  [AlertMessages.noPermissionInvoicesSpecificClient]: "You don't have permission to view invoices from this client.",
  [AlertMessages.noPermissionCreditLimitSpecificClient]: "You don't have permission to view credit limit from this client.",
  [AlertMessages.noPermissionCertificatesSpecificClient]: "You don't have permission to view certificates from this client.",
  [AlertMessages.noPermissionConcretingRequestSpecificClient]: "You don't have request permission on this client.",
  [AlertMessages.noHaveInvoices]: "You have no invoices to view yet.",
  [AlertMessages.noHaveCertificates]: "You have no certificates to view yet.",
  [AlertMessages.noHaveInvoicesSpecificClient]: "This client has no invoices to view yet.",
  [AlertMessages.noHaveCertificatesSpecificClient]: "This client has no certificates to view yet.",
  [AlertMessages.noHaveConcretingRequestSpecificClient]: "This client has no requests to view yet.",
  [AlertMessages.noConcretingApproval]: "No concreting approval to view.",
  [AlertMessages.noConcreting]: "No concreting to view.",
  [AlertMessages.noContract]: "No contract to view.",
  [AlertMessages.noUser]: "No user to view."
};
